import { render, staticRenderFns } from "./coolDati.vue?vue&type=template&id=62d2fe1a&scoped=true&"
import script from "./coolDati.vue?vue&type=script&lang=js&"
export * from "./coolDati.vue?vue&type=script&lang=js&"
import style0 from "./coolDati.vue?vue&type=style&index=0&lang=css&"
import style1 from "./coolDati.vue?vue&type=style&index=1&id=62d2fe1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2fe1a",
  null
  
)

export default component.exports